/* eslint-disable camelcase, react-hooks/rules-of-hooks */
import { useQuery, UseQueryResult, useMutation } from 'react-query';
import axios from '@utils/axios';
import { Keyword } from '@api/database/models/keyword';
import { useSnackbar } from '@hooks/useSnackbar';
import queryClient from '../queryClient';

const queryKeywords = async (id: number): Promise<Keyword[]> => {
  const result = await axios.get<{
    data: Keyword[];
  }>(`/api/dashboard/keywords/get?id=${id}`);
  return result.data;
};

export function useGetKeywords(pageDealId: number): UseQueryResult<Keyword[]> {
  return useQuery<Keyword[], Error>(
    `keywords-${pageDealId}`,
    () => queryKeywords(pageDealId),
    {
      onError: () => {
        console.error(
          'Something went wrong while fetching the product features'
        );
      }
    }
  );
}

export function useToggleKeywordActive() {
  interface RequestData {
    id: number;
    isActive: boolean;
    pageDealId: number;
  }

  const mutationFn = async ({ isActive, id }: RequestData): Promise<null> => {
    return axios.post(`/api/dashboard/keywords/toggle-active`, {
      isActive,
      id
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries(`keywords-${variables?.pageDealId}`);
    },
    onError: () => {
      console.error('error toggling keyword');
    }
  });
}

export function useAddKeyword() {
  interface RequestData {
    keyword: string;
    pageDealId: number;
  }
  const { showMessage } = useSnackbar();

  const mutationFn = async ({
    keyword,
    pageDealId
  }: RequestData): Promise<{
    response?: string;
  }> => {
    return axios.post(`/api/dashboard/keywords/add`, {
      keyword,
      pageDealId
    });
  };

  return useMutation(mutationFn, {
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries(`keywords-${variables?.pageDealId}`);
      if (_data?.response) {
        showMessage(_data.response);
      }
    },
    onError: () => {
      console.error('error adding keyword');
    }
  });
}
